import { render, staticRenderFns } from "./dialog_setTag.vue?vue&type=template&id=3108df27&scoped=true&"
import script from "./dialog_setTag.vue?vue&type=script&lang=js&"
export * from "./dialog_setTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3108df27",
  null
  
)

export default component.exports